/**
 * @enum
 * @description - Case Type options
 */
export enum CaseTypeOptions {
  ALL,
  CASE,
  SUB_CASE,
}
